"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireDefault(require("react"));

var _usePreferredLocale = _interopRequireDefault(require("@sprinx/react-globalize/usePreferredLocale"));

var _useFindByBannerPositionServiceCall = _interopRequireDefault(require("./useFindByBannerPositionServiceCall"));

//
function useBanners(position, bannerSizeCode) {
  var _React$useState = _react.default.useState([]),
      _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
      banners = _React$useState2[0],
      setBanners = _React$useState2[1];

  var bannersServiceCall = (0, _useFindByBannerPositionServiceCall.default)();
  var locale = (0, _usePreferredLocale.default)();

  var filteredBanners = _react.default.useMemo(function () {
    return banners.map(function (b) {
      return (0, _extends2.default)({}, b, {
        media: b.media.filter(function (m) {
          return m.size === bannerSizeCode && m.src && m.locale === locale;
        })
      });
    }).filter(function (b) {
      return b.media && b.media.length > 0;
    });
  }, [bannerSizeCode, banners, locale]);

  _react.default.useEffect(function () {
    if (!bannerSizeCode || !locale || !position) {
      setBanners(null);
    }

    var timer = setTimeout(function () {
      bannersServiceCall(position, locale, bannerSizeCode).then(function (r) {
        return setBanners(r);
      });
    }, 300);
    return function () {
      return clearTimeout(timer);
    };
  }, [bannerSizeCode, bannersServiceCall, position, locale]);

  return filteredBanners;
}

var useBannersDummy = function useBannersDummy() {
  return function () {
    return [];
  };
};

var useBannersSafe = typeof window !== 'undefined' ? useBanners : useBannersDummy;
var _default = useBannersSafe;
exports.default = _default;